//new icon name
export const ICON = {
  NEW_CLOSE_ICON: "newCloseIcon",
  PERSON_ICON: "personIcon",
  SPLIT_ICON: "splitIcon",
  RIGHT_ARROW_ICON: "rightArrowIcon",
  DISCOUNT_ICON: "discountIcon",
  INFO_ICON: "infoIcon",
  CLOSE_ICON: "closeIcon",
  OFFLINE_BOLT_ICON: "offlineBoltIcon",
  CLEAR_ICON: "clearIcon",
  BACK_ARROW_ICON: "backArrowIcon",
  CONFIRM_ICON: "confirmIcon",
  CONFIRM_ICON_LINE: "confirmLineIcon",
  EVENT_AVAILABLE_ICON: "eventAvailable",
  FORWARD_ARROW_ICON: "forwardArrowIcon",
  PAYMENT_ICON: "paymentIcon",
  FILLED_STAR_ICON: "filledStarIcon",
  THUMBSUP_FILLED_ICON: "thumbsUpFilled",
  THUMBS_UP: "thumbsUp",
  FAVOURITE_ICON: "favouriteIcon",
  FAVOURITE_FILLED_ICON: "filledFavouriteIcon",
  HELP_ICON: "helpIcon",
  SHARE_ICON: "shareIcon",
  CROWN_ICON: "crownIcon",
  DONE_ALL_ICON: "doneAllIcon",
  LOCATION_ON_ICON: "locationOnIcon",
  GROUP_ICON: "groupIcon",
  GROUPS_ICON: "groupsIcon",
  GAVEL_ICON: "gavelIcon",
  TIMER_ICON: "timerIcon",
  DOWN_ARROW_ICON: "downArrowIcon",
  DONE_ICON: "doneIcon",
  WALLET_ICON: "walletIcon",
  PROFILE_ICON: "profileIcon",
  TUNE_ICON: "tuneIcon",
  ARROW_FORWARD_ICON: "arrowForwardIosIcon",
  ARROW_DROPUP_ICON: "arrowDropUpIcon",
  ARROW_DROPDOWN_ICON: "arrowDropDownIcon",
  ARROW_UNCHANGED: "arrowUnchanged",
  PRICE_UP_ICON: "priceUp",
  PRICE_DOWN_ICON: "priceDown",
  HOME_ROUNDED: "homeRounded",
  SCORBOARD: "SCORBOARD",
  EVENTS: "evetsIcon",
  SEARCH_ICON: "searchIcon",
  BOOKING_ICON: "bookingIcon",
  LEARBOARD_ICON: "leaderboardIcon",
  CHECKED_RADIO_ICON: "checkRadioIcon",
  UNCHECKED_RADIO_ICON: "uncheckRadioIcon",
  CHECKED_CIRCLE: "checkedCircle",
  CLICK_ICON: "clickIcon",
  REVIEW_ICON: "reviewIcon",
  ADD_CIRCLE_ICON: "addCircleIcon",
  CALENDER_ICON: "dateRangeIcon",
  PENCIL: "create",
  DELETE: "delete",
  CAMERA_OUTLINED_ICON: "cameraOutlinedIcon",
  WARNING_ICON: "warningIcon",
  EXPAND_LESS_ICON: "expandIcon",
  GPS_FIXED_ICON: "gpsFixedIcon",
  BLOCK_ICON: "blockIcon",
  CUSTOMER_SUPPORT_ICON: "customerSupportIcon",
  COMMENT_ICON: "commentIcon",
  RUPEES_SYMBOL_ICON: "rupeesSymbolIcon",
  CANCELED_ICON: "canceledIcon",
  HELP_OUTLINED_ICON: "HelpOutlined",
  HOME_ICON: "homeIcon",
  COIN_ICON: "coinIcon",
  CALL_SPLIT: "callSplit",
  CANCELLED_ROUND_ICON: "cancelledRoundIcon",
  TROPHY_ICON: "trophyIcon",
  MAGNIFIER_ICON: "magnifierIcon",
  SCHEDULE_ICON: "scheduleIcon",
  INJUREY_ICON: "injureyIcon",
  DISCOUNT_STROKE_ICON: "discountIconStroke",
  FEEDBACK_ICON: "feedBackIcon",
  MORNING_IMAGE_ICON: "morningImage",
  AFTERNOON_IMAGE_ICON: "afternoonImage",
  EVENING_IMAGE_ICON: "eveningImage",
  NIGHT_IMAGE_ICON: "nightImage",
  MIDNIGHT_IMAGE_ICON: "midNightImage",
  DIRECTION_ICON: "DirectionIcon",
  LOAD_MORE_ICON: "loadMoreIcon",
  INSTAGRAM_ICON: "instagramIcon",
  Add_LOCATION_ICON: "addLocationIcon",
  CLOUD_OFF_ICON: "cloudOffIcon",
  HOUR_GLASS_ICON: "hourGlass",
  PNP_ICON: "pnpIcon",
  BAG_ICON: "bagIcon",
  WHISTLE_ICON: "whistleIcon",
  NEW_USER_ICON: "newUserIcon",
  KM_ICON: "kmIcon",
  TRADITIONAL_DANCE_ICON: "TraditionalDanceIcon",
  BASKETBALL_ICON: "BasketballIcon",
  TABLETENNIS_ICON: "TableTennisIcon",
  SWIMMER_ICON: "SwimmerIcon",
  TENNIS_ICON: "TennisIcon",
  BADMINTON_ICON: "BadmintonIcon",
  KICKBALL_ICON: "KickballIcon",
  CRICKET_ICON: "CricketIcon",
  WATER_BOTTLE_ICON: "WaterBottleIcon",
  GOGGLE_ICON: "GoggleIcon",
  HANGER_ICON: "HangerIcon",
  LAUNDRY_ICON: "LaundryIcon",
  MINUS_ICON: "MinusIcon",
  TEXT_THUMBNIL_ICON: "TextThumbnilIcon",
  MUMBAI_ICON: "MumbaiIcon",
  DELHI_NCR_ICON: "DelhiNcrIcon",
  KOCHI_ICON: "KochiIcon",
  SURAT_ICON: "SuratIcon",
  PUNE_ICON: "PuneIcon",
  THANE_ICON: "ThaneIcon",
  BENGALURU_ICON: "BengaluruIcon",
  HYDERABAD_ICON: "HyderabadIcon",
  AHMEDABAD_ICON: "AhmedabadIcon",
  EYE_ICON: "EyeIcon",
  PARTICIPANT_ICON: "ParticipantIcon",
  CERTIFICATE_ICON: "CertificateIcon",
  ERROR_INFO_ICON: "ErrorInfoIcon",
  STAR_ICON: "StarIcon",
  WRITE_ICON: "WriteIcon",
  BACK_ICON: "BackICon",
  CLOSE_ICON: "CloseIcon",
  LINE_ICON: "LineIcon",
  MESSAGE_ICON: "MessageIcon",
};

//Icon name
export const SPLIT_ICON = "splitIcon";
export const RIGHT_ARROW_ICON = "rightArrowIcon";
export const INFO_ICON = "infoIcon";
export const CLOSE_ICON = "closeIcon";
export const OFFLINE_BOLT_ICON = "offlineBoltIcon";
export const CLEAR_ICON = "clearIcon";
export const BACK_ARROW_ICON = "backArrowIcon";
export const CONFIRM_ICON = "confirmIcon";
export const CONFIRM_ICON_LINE = "confirmLineIcon";
export const EVENT_AVAILABLE_ICON = "eventAvailable";
export const FORWARD_ARROW_ICON = "forwardArrowIcon";
export const PAYMENT_ICON = "paymentIcon";
export const FILLED_STAR_ICON = "filledStarIcon";
export const THUMBSUP_FILLED_ICON = "thumbsUpFilled";
export const FAVOURITE_ICON = "favouriteIcon";
export const FAVOURITE_FILLED_ICON = "filledFavouriteIcon";
export const HELP_ICON = "helpIcon";
export const SHARE_ICON = "shareIcon";
export const DONE_ALL_ICON = "doneAllIcon";
export const LOCATION_ON_ICON = "locationOnIcon";
export const GROUP_ICON = "groupIcon";
export const GAVEL_ICON = "gavelIcon";
export const PERSON_ICON = "personIcon";

